import { useEffect, useState } from "react";
import { api, money } from "@/lib/api";
import { toast } from "sonner";

const STATUSES = ["pending", "processing", "dispatched", "delivered", "cancelled"];

export default function AdminOrders() {
    const [orders, setOrders] = useState([]);

    function load() {
        api.get("/admin/orders").then((r) => setOrders(r.data));
    }
    useEffect(load, []);

    async function updateStatus(id, status) {
        await api.put(`/admin/orders/${id}/status`, { status });
        toast.success("Status updated");
        load();
    }

    return (
        <div className="p-8" data-testid="admin-orders">
            <h1 className="font-display text-3xl font-bold mb-1">Orders</h1>
            <p className="text-sm text-muted-foreground mb-8">{orders.length} total</p>

            <div className="bg-white border border-border overflow-x-auto">
                <table className="w-full text-sm">
                    <thead className="bg-muted text-left">
                        <tr>
                            <th className="px-4 py-3">Order #</th>
                            <th className="px-4 py-3">Customer</th>
                            <th className="px-4 py-3">Items</th>
                            <th className="px-4 py-3">Total</th>
                            <th className="px-4 py-3">Payment</th>
                            <th className="px-4 py-3">Status</th>
                            <th className="px-4 py-3">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {orders.map((o) => (
                            <tr key={o.id} className="border-t border-border" data-testid={`admin-order-${o.order_number}`}>
                                <td className="px-4 py-3 font-mono text-xs font-bold">{o.order_number}</td>
                                <td className="px-4 py-3">
                                    <div className="font-semibold">{o.shipping_name}</div>
                                    <div className="text-xs text-muted-foreground">{o.shipping_email}</div>
                                </td>
                                <td className="px-4 py-3">{o.items.reduce((s, i) => s + i.quantity, 0)}</td>
                                <td className="px-4 py-3 font-semibold">{money(o.total)}</td>
                                <td className="px-4 py-3">
                                    <div className="text-xs">{o.payment_method.replace(/_/g, ' ')}</div>
                                    <div className="text-[10px] uppercase tracking-wider text-muted-foreground">{o.payment_status}</div>
                                </td>
                                <td className="px-4 py-3">
                                    <select
                                        value={o.status}
                                        onChange={(e) => updateStatus(o.id, e.target.value)}
                                        className="border border-border px-2 py-1 text-xs bg-white"
                                        data-testid={`status-select-${o.order_number}`}
                                    >
                                        {STATUSES.map((s) => <option key={s} value={s}>{s}</option>)}
                                    </select>
                                </td>
                                <td className="px-4 py-3 text-xs text-muted-foreground">{new Date(o.created_at).toLocaleString()}</td>
                            </tr>
                        ))}
                        {orders.length === 0 && (
                            <tr><td colSpan="7" className="text-center py-12 text-muted-foreground">No orders yet</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
